import { ArrowRight } from "lucide-react";
import RequestDemoButton from "@/components/demo/RequestDemoButton";

const CallToAction = () => {
  return (
    <section className="py-24 px-4 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-accent/5 to-background/95"></div>
      <div className="max-w-3xl mx-auto text-center relative">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
          Ready to Transform Your Practice?
        </h2>
        <p className="text-lg text-white/70 mb-8">
          Join leading immigration consultants and law firms already using NAVISA Enterprise
        </p>
        <div className="flex justify-center">
          <RequestDemoButton 
            className="bg-white hover:bg-white/90 text-black px-8 py-6 text-lg transition-all duration-300"
            tracking={{ source: 'enterprise_cta' }}
          >
            Request Demo
            <ArrowRight className="ml-2 h-5 w-5" />
          </RequestDemoButton>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;